import React from "react";
import { Spinner } from "@chakra-ui/react";

const Loader = ({isEnd}) => {

  if (isEnd) {
    return (
      <div className="loading-end">
        <Spinner />
      </div>
    );
  }
  return (
    <div className="loading-center">
      <Spinner />
    </div>
  );
};

export default Loader;
